import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import API_BASE from '../../config';

function ProtectedRoute({ children, adminRequired = false }) {
  const [authState, setAuthState] = useState('checking'); // 'checking', 'valid', 'invalid', 'not_admin'
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      setAuthState('invalid');
      return;
    }

    // Check token expiry by decoding JWT payload
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      if (payload.exp && payload.exp < now) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setAuthState('invalid');
        return;
      }
    } catch {
      // Malformed token
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setAuthState('invalid');
      return;
    }

    // For admin routes, verify admin status server-side
    if (adminRequired) {
      fetch(`${API_BASE}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error('Auth failed');
          return res.json();
        })
        .then((data) => {
          if (data.is_admin) {
            setAuthState('valid');
          } else {
            setAuthState('not_admin');
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setAuthState('invalid');
        });
    } else {
      setAuthState('valid');
    }
  }, [token, adminRequired]);

  if (authState === 'checking') {
    return null; // Don't render anything while verifying
  }

  if (authState === 'invalid') {
    return <Navigate to="/login" replace />;
  }

  if (authState === 'not_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
